import { isRectSeries } from './type-guards.js';
import { safeGet } from '../../core/utils/safe-get.js';
import type {
  RectSeriesToMetadata,
  SeriesToMetadata,
  XYChartSeriesWithDatapoints,
} from '../types/xy-chart-internals.js';

export const isRangeLegend = (
  seriesToMetadata: SeriesToMetadata | RectSeriesToMetadata,
  firstSeries: XYChartSeriesWithDatapoints,
) => {
  if (isRectSeries(firstSeries)) {
    const { valueType } = safeGet(seriesToMetadata, firstSeries);
    return valueType === 'range';
  }
};
